import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

const Button = (props) => {
  const { children, color, className, disabled, onClick, 'data-aaa': dataAaa } = props;

  const buttonClasses = classnames([
    className,
    styles.button,
    color && styles[`${color}Color`],
  ]);

  return (
    <button
      data-aaa={dataAaa}
      type="button"
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={styles.span}>{children}</span>
    </button>
  );
};

export default Button;
